// packages/components/src/visually-hidden/component.tsx
import { useContextSystem, contextConnect } from "../context/index.mjs";
import { visuallyHidden } from "./styles.mjs";
import { View } from "../view/index.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
function UnconnectedVisuallyHidden(props, forwardedRef) {
  const {
    style: styleProp,
    ...contextProps
  } = useContextSystem(props, "VisuallyHidden");
  return /* @__PURE__ */ _jsx(View, {
    ref: forwardedRef,
    ...contextProps,
    "data-visually-hidden": "",
    style: {
      ...visuallyHidden,
      ...styleProp || {}
    }
  });
}
var VisuallyHidden = contextConnect(UnconnectedVisuallyHidden, "VisuallyHidden");
var component_default = VisuallyHidden;
export {
  VisuallyHidden,
  component_default as default
};
//# sourceMappingURL=component.mjs.map
